const RadioOptionGroup = ({ name, value, options, onChange, error }) => {
  return (
    <>
      <div className="flex flex-wrap items-center gap-4">
        {options.map(opt => {
          // Convertir el option a valor numérico para la comparación
          const optionValue = (opt === 'SÍ' || opt === 'SI') ? 1 : 0;
          
          return (
            <label
              key={opt}
              className={`inline-flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-2 text-sm font-semibold transition ${
                value === optionValue
                  ? 'border-red-200 bg-red-50 text-red-700'
                  : 'border-slate-300 bg-white text-slate-700 hover:bg-slate-50'
              }`}
            >
              <input
                type="radio"
                name={name}
                value={opt}
                checked={value === optionValue}
                onChange={() => onChange(name, opt)}
                className="h-4 w-4 border-slate-400 text-red-600 focus:ring-red-400"
              />
              <span>{opt}</span>
            </label>
          );
        })}
      </div>
      {error && (
        <p className="mt-1 text-xs font-medium text-red-600">{error}</p>
      )}
    </>
  );
};

export default RadioOptionGroup;
